"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";

import { AppErrorPanel } from "@/components/app-error-panel";

export default function AppSegmentError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return <AppErrorPanel variant="segment" onRetry={reset} digest={error.digest} />;
}
